<template>
  <div>
    <ReactWrapper :component="OrganizationJoin" :props="props" />
  </div>
</template>

<script>
  import { OrganizationJoin } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'OrganizationJoin',

    components: {
      ReactWrapper,
    },

    props: {
      token: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      OrganizationJoin,
    }),

    computed: {
      props() {
        return {
          token: this.token,
        };
      },
    },
  };
</script>
